import { CallAudioUploadCallIdentifier } from '../store/state/callAudioUploadState';

export function doCallAudioIdentifiersMatch(identifier1: CallAudioUploadCallIdentifier, identifier2: CallAudioUploadCallIdentifier, typeMustMatch: boolean): boolean {
	if (typeMustMatch) {
		if (identifier1.type === 'call' && identifier2.type === 'call')
			return identifier1.id === identifier2.id;

		if (identifier1.type === 'filename' && identifier2.type === 'filename')
			return identifier1.filename === identifier2.filename;

		return false;
	} else {
		if (identifier1.type === 'call' && identifier2.type === 'call')
			return identifier1.id === identifier2.id;

		return identifier1.filename === identifier2.filename;
	}
}


